import React, { useEffect, useMemo, useState } from 'react';
import styles from './header.module.scss';
import { TabMenu } from 'primereact/tabmenu';
import { useLocation, useNavigate } from 'react-router-dom';
import SignOut from './sign-out/sign-out';

const menus = [
  {
    label: 'Sales Configuration Monitoring',
    url: '/',
  },
  {
    label: 'Player Attributes',
    url: '/player-attributes',
  },
  {
    label: 'Sales Steering',
    url: '/sales-steering',
  },
  {
    label: 'Booking Restrictions',
    url: '/booking-restrictions',
  },
  {
    label: 'Accommodation Blocking',
    url: '/accommodation-blocking',
  },
];

function Header() {
  const location = useLocation();
  const navigate = useNavigate();
  const currentUrl = location.pathname;
  const [itemsSource] = useState(menus);

  const currentIndex = useMemo(() => {
    return itemsSource.findIndex((item) => item.url === currentUrl || currentUrl.startsWith(`${item.url}/`));
  }, [currentUrl, itemsSource]);

  const [activeIndex, setActiveIndex] = useState(currentIndex);

  useEffect(() => {
    setActiveIndex(currentIndex);
  }, [currentIndex]);

  return (
    <div className={styles.header}>
      <div className={styles.home}>
        <img alt="logo" src={window.location.origin + '/logo-sunwebgroup.svg'} height="40" className="mr-2"></img>
      </div>
      <TabMenu
        className={styles.tabMenu}
        model={itemsSource}
        activeIndex={activeIndex}
        onTabChange={(event) => {
          const mouseEvent = event.originalEvent as React.MouseEvent;
          // Let the browser handle modifier-clicks natively so "open in new tab" keeps working.
          if (mouseEvent.ctrlKey || mouseEvent.metaKey || mouseEvent.shiftKey || mouseEvent.altKey) {
            return;
          }
          // TabMenu renders items that have a `url` as real <a href> anchors, and PrimeReact only
          // calls preventDefault() for items without a url. Without preventing it here, every tab
          // click performs a native browser navigation that fully reloads the SPA, which makes the
          // TabMenu briefly paint as an unstyled bullet list on each switch (TD-10680).
          mouseEvent.preventDefault();
          setActiveIndex(event.index);
          navigate(itemsSource[event.index].url);
        }}
      />
      <SignOut />
    </div>
  );
}

export default Header;
